export const MODULE_KEY_MAP = {
  CASES: 'causas',
  SMART_DOCUMENTS: 'smart documents',
  CRM: 'crm',
  TASKS: 'tareas',
  MESSAGING: 'mensajería',
  ARTIFICIAL_INTELLIGENCE: 'inteligencia artificial',
  SETTINGS: 'configuración',
  DAILY_STATE: 'estado diario',
  REPORTS: 'informes',
  CALENDAR: 'calendario',
  MARKETING: 'marketing',
  AGENDA: 'agenda',
};

export const CONFIG_SECTION_CODES = {
  CONFIG_SECTION: 'CONFIGURACION.VER_SECCION_163',
  EMPRESA: 'CONFIGURACION.VER_SECCION_165',
  USUARIOS: 'CONFIGURACION.VER_SECCION_171',
  PERFILES_Y_ROLES: 'CONFIGURACION.VER_SECCION_176',
  GESTION_DE_DATOS: 'CONFIGURACION.GESTION_DE_DATOS.VER_SECCION',
  ROLEO_AUTOMATICO: 'CONFIGURACION.VER_SECCION_182',
  PROTOCOLOS: 'CONFIGURACION.VER_SECCION_186',
  DOCUMENTOS: 'CONFIGURACION.VER_SECCION_192',
  PAGOS_Y_SUSCRIPCIONES: 'CONFIGURACION.VER_SECCION_198',
  LOG_AUDITORIA: 'CONFIGURACION.VER_SECCION_206',
  SUPLENCIAS: 'CONFIGURACIÓN.SUPLENCIAS.VER_SECCION',
  INTEGRACION: 'CONFIGURACIÓN.INTEGRACION.VER_SECCION',
  LOG_LOGIN: 'CONFIGURACIÓN.LOG_LOGIN.VER_SECCION',
};
